import { render } from "./SpecialSize.vue?vue&type=template&id=60d8de5e&scoped=true"
import script from "./SpecialSize.vue?vue&type=script&lang=js"
export * from "./SpecialSize.vue?vue&type=script&lang=js"

import "./SpecialSize.vue?vue&type=style&index=0&id=60d8de5e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d8de5e"]])

export default __exports__